import { IHttpApi } from '@cian/http-api';
import {
  IAgentAvailability as IChatAgentAvailability,
  IStartChatPopupProps,
  StartChatPopup,
} from '@cian/start-chat-popup-component';
import * as React from 'react';
import { sendFirstMessage } from '../../../api/chats';
import { IAgentAvailability } from '../../../types/offer';
import { trackFirstMessageSend } from './tracking';

const styles = require('./index.css');

/**
 * Назание события, которое отправляем в dataLayer.push,
 * чтобы вызвать системный попап подписки на push-уведомления.
 */
const FLOCKTORY_KEY_EVENT = 'show_push_cian_site';

interface IChatWidgetProps extends Partial<IStartChatPopupProps> {
  agentAvailability?: IAgentAvailability | null;
  /* offer по которому дергается чат принадлежит текущему пользователю */
  isOwnOfferChat: boolean;
  httpApi: IHttpApi;
  offerId: number;
  userPhone?: string;
  defaultPhone?: string;
  defaultEmail?: string;
  showPushNotification?: boolean;
  onClose?(): void;
}

export class ChatWidget extends React.PureComponent<IChatWidgetProps> {
  public render() {
    const {
      agentAvailability,
      offerId,
      userPhone,
      defaultEmail,
      defaultPhone,
      onClose,
      isOwnOfferChat,
      showPushNotification,
      ...rest} = this.props;

    return (
      <div className={styles['chat']}>
        <StartChatPopup
          defaultPhone={defaultPhone}
          defaultEmail={defaultEmail}
          defaultMessage={'Здравствуйте! Заинтересовало ваше предложение.\u000AПожалуйста, свяжитесь со мной'}
          inFocus
          sendFirstMessage={sendFirstMessage(this.props.httpApi)}
          offerId={offerId}
          error={isOwnOfferChat ? 'Вы не можете написать сообщение самому себе' : undefined}
          headerProps={{
            agentAvailability: agentAvailability as IChatAgentAvailability,
            phones: userPhone ? [userPhone] : undefined,
          }}
          onCloseClick={onClose}
          isShowPushCheckbox={showPushNotification}
          onFlocktoryCallback={this.sendSystemPushNotificationPopup}
          {...rest}
        />
      </div>
    );
  }

  private sendSystemPushNotificationPopup = (isPushCheck: boolean) => {
    const { showPushNotification } = this.props;

    if (window.dataLayer && isPushCheck) {
      window.dataLayer.push({ event: FLOCKTORY_KEY_EVENT });
    }

    trackFirstMessageSend(Boolean(showPushNotification), isPushCheck);
  }
}
